import { render } from "./OrganisationFormView.vue?vue&type=template&id=2d0f18b8&scoped=true"
import script from "./OrganisationFormView.vue?vue&type=script&lang=js"
export * from "./OrganisationFormView.vue?vue&type=script&lang=js"

import "./OrganisationFormView.vue?vue&type=style&index=0&id=2d0f18b8&lang=less&scoped=true"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0f18b8"]])

export default __exports__